// @ts-nocheck
import React from "react";
import { StatusBadge } from "@/components/ui";

export const StockBadge = ({ status }) => {
  const m = {
    OK: ["ACTIVE", "In Stock"],
    LOW: ["WARNING", "Low"],
    CRITICAL: ["FAILED", "Critical"],
    OUT: ["BLOCKED", "Out"],
  };
  const [s, l] = m[status] || ["DISABLED", status];
  return (
    <StatusBadge status={s} showDot>
      {l}
    </StatusBadge>
  );
};
